import { useUsers } from 'components/dataProviders/withUsers';
import { userModelToLabelledWithEmail } from 'shared/domain/user/mapping/toView';
import { useProjectOrganizationId } from 'store/project';
import { TranslationKey } from 'intl/types/translationKey';
import { createEntityFilterInput } from '../common';

interface UserEntityFilterInputConfig {
  labelId: TranslationKey;
  id: string;
}

export function createUserEntityFilterInput({
  labelId,
  id,
}: UserEntityFilterInputConfig) {
  return createEntityFilterInput({
    useData: () => {
      const {
        all: { items: users },
      } = useUsers();
      const organizationId = useProjectOrganizationId();
      return { users, organizationId };
    },
    transformData: ({ users, organizationId }) =>
      users.map((user) => userModelToLabelledWithEmail(user, organizationId)),
    labelId,
    id,
  });
}
